import { render } from "./FUploadFile.vue?vue&type=template&id=99a938e4&scoped=true"
import script from "./FUploadFile.vue?vue&type=script&lang=js"
export * from "./FUploadFile.vue?vue&type=script&lang=js"

import "./FUploadFile.vue?vue&type=style&index=0&id=99a938e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a938e4"]])

export default __exports__